export const GET_CONTACT_LIMIT = 'GET_CONTACT_LIMIT';
export const GET_CONTACT_LIMIT_SUCCESS = 'GET_CONTACT_LIMIT_SUCCESS';
export const GET_CONTACT_LIMIT_FAILURE = 'GET_CONTACT_LIMIT_FAILURE';

export const GET_INSURANCE_COMPANIES_OPTION = "GET_ISURANCE_COMPANIES_OPTION";
export const GET_INSURANCE_COMPANIES_OPTION_SUCCESS = "GET_ISURANCE_COMPANIES_OPTION_SUCCESS";
export const GET_INSURANCE_COMPANIES_OPTION_FAILURE = "GET_ISURANCE_COMPANIES_OPTION_FAILURE";

export const GET_POLICY_OPTION = "GET_POLICY_OPTION";
export const GET_POLICY_OPTION_SUCCESS = "GET_POLICY_OPTION_SUCCESS";
export const GET_POLICY_OPTION_FAILURE = "GET_POLICY_OPTION_FAILURE";

